export default __webpack_public_path__ + "static/media/Objectf.a77e3d4e.png";